import {combineReducers} from 'redux';
import auth from './auth';

import heartposts from './heartposts'
import heartprediction from './heartprediction';

import diabetesposts from './diabetesposts'
import diabetesprediction from './diabetesprediction';

import strokeposts from './strokeposts'
import strokeprediction from './strokeprediction';

import creditposts from './creditposts'
import creditprediction from './creditprediction';

import loanposts from './loanposts'
import loanprediction from './loanprediction';

import insuranceposts from './insuranceposts'
import insuranceprediction from './insuranceprediction';

import totalPages from './totalpages';


export default combineReducers({ auth, heartposts, heartprediction, diabetesposts, 
                                 diabetesprediction, strokeposts, strokeprediction, 
                                 creditposts, creditprediction, loanposts, loanprediction, 
                                 insuranceposts, insuranceprediction, totalPages});